import {TypeOuvrage} from 'app/shared/model/type-ouvrage';
import {Column} from 'app/shared/service/table.service';
import {QualificationParametre} from 'app/shared/model/qualification-parametre';
import {ParentElement} from 'app/shared/model/parent-element';
import {Ouvrage} from 'app/shared/model/ouvrage';

export const parametreQualifications: any[] = [
    {default: true, value: '', text: 'Informé', letter: 'I', class: 'qualif-I'},
    {value: 'ESTIME', text: 'Estimé', letter: 'E', class: 'qualif-E'},
    {value: 'REGLEMENTAIRE', text: 'Règlementaire', letter: 'R', class: 'qualif-R'},
    {value: 'CALCULE', text: 'Calculé', letter: 'C', class: 'qualif-C'},
    {value: 'PROPAGE', text: 'Propagé', letter: 'P', class: 'qualif-P'},
    {value: 'MESURE', text: 'Mesuré', letter: 'M', class: 'qualif-M'},
    {value: 'DOCUMENTE', text: 'Documenté', letter: 'D', class: 'qualif-D'}
];

export class OuvragesUtils {

    /**
     * Renvoie la liste des ids des bâtiments parents
     */
    static getParentBatimentsIds(ouvrages: Ouvrage[]): string[] {
        const parentsBatiment = ouvrages.map(ouvrage => ouvrage.parents.find(p => p.type == 'BATIMENT'));
        return parentsBatiment.map(bat => bat.id).filter((el, i, a) => i === a.indexOf(el));
    }

    /**
     * Retourne le type ouvrage commun le plus proche
     */
    static getTypeOuvrageCommun(ouvrages: Ouvrage[], allTypes: TypeOuvrage[]): TypeOuvrage {
        // récupère le type complet à partir de "allTypes" (car sur les ouvrages, on a pas la liste des parents sur typeOuvrage)
        const types = ouvrages.map(ouvrage => allTypes.find(it => it.id == ouvrage.typeOuvrage.id || it.codeBim == ouvrage.typeOuvrage.codeBim));
        // conserve les types dont tous les ouvrages sont de ce type ou d'un enfant de ce type, et les trie par ordre de parentalité
        const typesCommuns = allTypes
            .filter(t => types.every(type => type.parents.indexOf(t.id) > -1 || type.id === t.id))
            .sort((a, b) => a.parents.length - b.parents.length);
        // prend le type de plus bas niveau
        return typesCommuns.length ? typesCommuns[typesCommuns.length - 1] : null;
    }

    /**
     * Renvoie le parent commun à tous ces éléments de type lot ou pièce.
     * Si le parent commun est de niveau >= bâtiment, alors nul est renvoyé.
     */
    static getParentLotPieceCommun(ouvrages: Ouvrage[]): ParentElement {
        for (const typeElement of ['PIECE', 'LOT']) {
            if (ouvrages.every(el => el.parents.find(p => p.type == typeElement) != null)) {
                const parents = ouvrages.map(el => el.parents.find(p => p.type == typeElement));
                if (parents.length && parents.map(p => p.id).filter((el, i, a) => i === a.indexOf(el)).length == 1) {
                    return parents[0];
                }
            }
        }
        return null;
    }

    /**
     * Renvoie la qualification textuelle, ou NULL si valeur par défaut.
     */
    static getQualificationTextOrNull(propertyName: string, ouvrage) {
        const parameterName = propertyName.substr(0, propertyName.indexOf(Column.QUALIFICATION_COLUMN_SUFFIX));
        return ouvrage.parametresQualifs[parameterName];
    }

    /**
     * Renvoie la qualification textuelle, ou la valeur textuelle par défaut.
     */
    static getQualificationText(propertyName: string, ouvrage) {
        const qualifTextOrNull: string = OuvragesUtils.getQualificationTextOrNull(propertyName, ouvrage);
        // La valeur "INFORME" correspond à null, car c'est la valeur par défaut (non renseigné en base)
        return qualifTextOrNull == null ? QualificationParametre[QualificationParametre.INFORME] : qualifTextOrNull;
    }

    static getDefaultParametreQualification(): any {
        return parametreQualifications.filter(q => q.default === true)[0];
    }

    static getParametreQualifLetter(qualif: string): string {
        const qualifElement = parametreQualifications.find(e => e.value == qualif); // use double equal for empty string to equal null
        return qualifElement ? qualifElement.letter : OuvragesUtils.getDefaultParametreQualification().letter;
    }

    static getParametreQualifClass(qualif: string): string {
        const qualifElement = parametreQualifications.find(e => e.value == qualif); // use double equal for empty string to equal null
        return qualifElement ? qualifElement.class : OuvragesUtils.getDefaultParametreQualification().class;
    }

    static getParametreQualifText(qualif: string): string {
        const qualifElement = parametreQualifications.find(e => e.value == qualif); // use double equal for empty string to equal null
        return qualifElement ? qualifElement.text : OuvragesUtils.getDefaultParametreQualification().text;
    }

}
